import React, {useState} from "react";
import FilterTicketModal from "../FilterTicketModal/FilterTicketModal";
import SearchTicketModal from "../SearchTicketModal/SearchTicketModal";
import Table from "../Table/Table";
import "./TableView.css";

const TableView = ({
                       title,
                       columns,
                       filters,
                       tickets,
                       totalPages,
                       isLoading,
                       page,
                       clients,
                       services,
                       states,
                       setFilters,
                       setPage,
                       handleAdd,
                       disableAddButton = false,
                       onRowClick,
                   }: {
    title: string;
    columns: string[];
    filters: object;
    tickets: any[];
    totalPages: number;
    isLoading: boolean;
    page: number;
    clients: any[];
    services: any[];
    states: any[];
    setFilters: (filters: object) => void;
    setPage: (page: number) => void;
    handleAdd?: () => void;
    disableAddButton?: boolean;
    onRowClick?: (row: Record<string, any>) => void;
}) => {
    const [isSearchModalVisible, setSearchModalVisible] = useState(false);
    const [isFilterModalVisible, setFilterModalVisible] = useState(false);

    const handleResetTicketsTable = () => {
        setFilters({});
        setPage(0);
    };

    const handleSearchModal = (uniqueCode: string) => {
        setFilters({uniqueCode});
    };

    const handleFilterModal = (newFilters: object) => {
        setFilters(newFilters);
        setPage(0);
    };

    return (
        <div className="tickets-view-container">
            <div className="tickets-view-header">
                <div className="tickets-view-header-title">
                    <p>{title}</p>
                </div>
                {!disableAddButton && (
                    <span className="material-icons-outlined icon-unselected" onClick={handleAdd}>
                        add_box
                    </span>
                )}
                <span className="material-icons-outlined icon-unselected" onClick={() => setSearchModalVisible(true)}>
                    search
                </span>
                <span className="material-icons-outlined icon-unselected" onClick={() => setFilterModalVisible(true)}>
                    filter_alt
                </span>
                <span className="material-icons-outlined icon-unselected" onClick={handleResetTicketsTable}>
                    restart_alt
                </span>
            </div>
            {isLoading ? (
                <div className="loading-overlay">
                    <div className="spinner"></div>
                    <div className="loading-message">Obteniendo información...</div>
                </div>
            ) : (
                <div className="tickets-view-table">
                    <Table
                        columns={columns}
                        data={tickets}
                        totalPages={totalPages}
                        currentPage={page}
                        setCurrentPage={setPage}
                        onRowClick={onRowClick}
                    />
                </div>
            )}
            <SearchTicketModal
                isVisible={isSearchModalVisible}
                onClose={() => setSearchModalVisible(false)}
                onSearch={handleSearchModal}
                placeholder="Clave de ticket"
            />
            <FilterTicketModal
                isVisible={isFilterModalVisible}
                onClose={() => setFilterModalVisible(false)}
                onSearch={handleFilterModal}
                clients={clients}
                services={services}
                states={states}
            />
        </div>
    );
};

export default TableView;
